import { render, staticRenderFns } from "./RuleComponentV2.vue?vue&type=template&id=590e6543&scoped=true"
import script from "./RuleComponentV2.vue?vue&type=script&lang=js"
export * from "./RuleComponentV2.vue?vue&type=script&lang=js"
import style0 from "./RuleComponentV2.vue?vue&type=style&index=0&id=590e6543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e6543",
  null
  
)

export default component.exports